// src/components/ui/Card.tsx — paper card with subtle brass top edge.
import type { CSSProperties, ReactNode } from "react";
import { C } from "../../theme";

export interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  edge?: boolean;
  padded?: boolean;
  onClick?: () => void;
}

export const Card = ({ children, style, edge = true, padded = true, onClick }: CardProps) => (
  <div
    onClick={onClick}
    style={{
      background: C.card,
      borderRadius: 18,
      border: `1px solid ${C.hairlineLt}`,
      boxShadow: C.shadowS,
      padding: padded ? 16 : 0,
      position: "relative",
      overflow: "hidden",
      cursor: onClick ? "pointer" : "default",
      ...style,
    }}
  >
    {edge && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 18,
          right: 18,
          height: 2,
          background: `linear-gradient(90deg, transparent, ${C.brassLt} 20%, ${C.brassLt} 80%, transparent)`,
          opacity: 0.5,
          pointerEvents: "none",
        }}
      />
    )}
    {children}
  </div>
);
